import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private baseUrl = environment.authURL;

  constructor(private http: HttpClient) { }

  register(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/registration`, data);
  }

  getAllPrizes(): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/all-prizes`, {});
  }

  spin(id): Observable<any> {
    return this.http.post(`${this.baseUrl}/spin/${id}`, {}, { responseType: 'text' as 'text' });
  }

}
